import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=c59e4e38&scoped=true&"
import script from "./MenuManager.vue?vue&type=script&lang=js&"
export * from "./MenuManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e4e38",
  null
  
)

export default component.exports